import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'animate.css';
import './assets/index.scss'
import './assets/home.scss'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import i18n from './i18n.ts'
import './components/css/index.scss';
import './components/css/index.ts';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App)
app.use(router).use(ElementPlus).use(i18n).mount('#app')
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}